import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6 max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-6" }, "Zaświadczenie lekarskie (opcjonalne)", -1)

import { useField } from 'vee-validate';
import Dropzone from '../../ui/Dropzone.vue';
import { useOnDrop } from '../../../hooks/useOnDrop';


export default {
  __name: 'UploadedFileField',
  setup(__props) {

const { value, setValue } = useField('uploadedFile');

const { onDrop, onSelectFile } = useOnDrop(setValue);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Dropzone, {
      onChange: _unref(onSelectFile),
      "selected-file": _unref(value),
      onDrop: _withModifiers(_unref(onDrop), ["prevent"])
    }, null, 8, ["onChange", "selected-file", "onDrop"])
  ]))
}
}

}